import { createFileRoute } from "@tanstack/react-router";
import { AdminFlowsPage } from "@/features/admin/flows";

export const Route = createFileRoute("/admin/flows")({
  head: () => ({ meta: [{ title: "Flows · Admin · Malfak" }] }),
  component: AdminFlowsPage,
});
